import max from 'lodash/max';

import {
  PERIOD,
  PROVIDERS,
  PROVIDER_OPTION,
} from '../../../common/Charts/constants';
import { VITALS_ACTIVITY_TYPE } from '../../constants';
import { COLORS } from '../../../../constants/styles';
import { POINT_WITHOUT_HOVER } from '../../../common/Charts/options';

const { BLOOD_PRESSURE } = VITALS_ACTIVITY_TYPE;

const DEFAULTS = {
  radius: 3.5,
  borderWidth: 1.5,
  backgroundColor: 'transparent',
};

const CCD_SYSTOLIC = {
  ...DEFAULTS,
  pointStyle: 'rectRot',
  borderColor: COLORS.orangeRed,
  pointBackgroundColor: COLORS.orangeRed,
};

const CDD_SYSTOLIC_BY_PERIOD = {
  [PERIOD.DAY]: {
    ...CCD_SYSTOLIC,
  },
  [PERIOD.WEEK]: {
    ...CCD_SYSTOLIC,
  },
  [PERIOD.MONTH]: {
    ...CCD_SYSTOLIC,
  },
  [PERIOD.QUARTER]: {
    ...CCD_SYSTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
  [PERIOD.YEAR]: {
    ...CCD_SYSTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
};

const CCD_DIASTOLIC = {
  ...DEFAULTS,
  borderDash: [8, 4],
  pointStyle: 'rectRot',
  borderColor: COLORS.orangeRed,
  pointBackgroundColor: COLORS.orangeRed,
};

const CDD_DIASTOLIC_BY_PERIOD = {
  [PERIOD.DAY]: {
    ...CCD_DIASTOLIC,
  },
  [PERIOD.WEEK]: {
    ...CCD_DIASTOLIC,
  },
  [PERIOD.MONTH]: {
    ...CCD_DIASTOLIC,
  },
  [PERIOD.QUARTER]: {
    ...CCD_DIASTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
  [PERIOD.YEAR]: {
    ...CCD_DIASTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
};

const DEVICE_SYSTOLIC = {
  ...DEFAULTS,
  pointStyle: 'circle',
  borderColor: COLORS.black,
  pointBackgroundColor: COLORS.black,
};

const DEVICE_SYSTOLIC_BY_PERIOD = {
  [PERIOD.DAY]: {
    ...DEVICE_SYSTOLIC,
  },
  [PERIOD.WEEK]: {
    ...DEVICE_SYSTOLIC,
  },
  [PERIOD.MONTH]: {
    ...DEVICE_SYSTOLIC,
  },
  [PERIOD.QUARTER]: {
    ...DEVICE_SYSTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
  [PERIOD.YEAR]: {
    ...DEVICE_SYSTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
};

const DEVICE_DIASTOLIC = {
  ...DEFAULTS,
  borderDash: [8, 4],
  pointStyle: 'circle',
  borderColor: COLORS.black,
  pointBackgroundColor: COLORS.black,
};

const DEVICE_DIASTOLIC_BY_PERIOD = {
  [PERIOD.DAY]: {
    ...DEVICE_DIASTOLIC,
  },
  [PERIOD.WEEK]: {
    ...DEVICE_DIASTOLIC,
  },
  [PERIOD.MONTH]: {
    ...DEVICE_DIASTOLIC,
  },
  [PERIOD.QUARTER]: {
    ...DEVICE_DIASTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
  [PERIOD.YEAR]: {
    ...DEVICE_DIASTOLIC,
    ...POINT_WITHOUT_HOVER,
  },
};

const {
  NAME,
  ICON,
  NAME_ID,
  OPTIONS,
  RESOURCES,
  ACTIVE_ICON,
  DISABLED_ICON,
  SINGLE_VALUE_ICON,
  ACTIVE_SINGLE_VALUE_ICON,
} = PROVIDER_OPTION;
const { DAY, WEEK, MONTH } = PERIOD;

export const getCustomOptions = ({ period, date, formats, metric } = {}) => {
  const withPoint = [DAY, WEEK, MONTH].includes(period);

  return {
    date,
    metric,
    period,
    range: max,
    type: BLOOD_PRESSURE,
    tooltip: {
      showVerticalLine: true,
    },
    providers: {
      [PROVIDERS.DEVICES]: {
        [NAME]: formats[PROVIDERS.DEVICES],
        [ICON]: withPoint
          ? 'icon-graph-devices-line-point-black'
          : 'icon-graph-line-black',
        [ACTIVE_ICON]: withPoint
          ? 'icon-graph-devices-line-point-white'
          : 'icon-graph-line-white',
        [DISABLED_ICON]: withPoint
          ? 'icon-graph-devices-line-point-disable'
          : 'icon-graph-line-disable',
        [SINGLE_VALUE_ICON]: 'icon-graph-device-point-black',
        [ACTIVE_SINGLE_VALUE_ICON]: 'icon-graph-device-point-white',
        [RESOURCES]: {
          bpSystolic: {
            [ICON]: 'icon-graph-line-black',
            [OPTIONS]: DEVICE_SYSTOLIC_BY_PERIOD,
            [NAME_ID]: 'patient.healthboard.blood_pressure.systolic',
          },
          bpDiastolic: {
            [ICON]: 'icon-graph-dash-line',
            [OPTIONS]: DEVICE_DIASTOLIC_BY_PERIOD,
            [NAME_ID]: 'patient.healthboard.blood_pressure.diastolic',
          },
        },
      },
      [PROVIDERS.CCD]: {
        [NAME]: formats[PROVIDERS.CCD],
        [ICON]: withPoint
          ? 'icon-graph-health-record-line-orange'
          : 'icon-graph-line',
        [ACTIVE_ICON]: withPoint
          ? 'icon-graph-health-record-line-point-white'
          : 'icon-graph-line-white',
        [DISABLED_ICON]: withPoint
          ? 'icon-graph-health-record-line-point-disable'
          : 'icon-graph-line-disable',
        [SINGLE_VALUE_ICON]: 'icon-graph-health-record-point-orange',
        [ACTIVE_SINGLE_VALUE_ICON]: 'icon-graph-health-record-point-white',
        [RESOURCES]: {
          bpSystolic: {
            [ICON]: 'icon-graph-line-black',
            [OPTIONS]: CDD_SYSTOLIC_BY_PERIOD,
            [NAME_ID]: 'patient.healthboard.blood_pressure.systolic',
          },
          bpDiastolic: {
            [ICON]: 'icon-graph-dash-line',
            [OPTIONS]: CDD_DIASTOLIC_BY_PERIOD,
            [NAME_ID]: 'patient.healthboard.blood_pressure.diastolic',
          },
        },
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/TimeScalableChart/BloodPressureChart/options.js